import { createNewReference } from "../services/shared";

const agentReducer = ( state = [], action: any ) => {
  return createNewReference(state);
};

export { agentReducer };
